import React from 'react'
import CourseList from '../../features/admin/CourseList'

const CourseListPage = () => {
  return <CourseList/>
}

export default CourseListPage